import { subscribe, unsubscribe } from './cookie-consent'

export type HeapProperties = Record<string, string | number | boolean | null>

interface PendingEvent {
  name: string
  properties: HeapProperties
}

const pending: PendingEvent[] = []

const flushPending = (): void => {
  if (!window.heap) return

  pending.splice(0).forEach(({ name, properties }) => {
    window.heap.track(name, properties)
  })

  unsubscribe(flushPending)
}

// `window.heap` stays undefined until OneTrust cookie consent resolves, which
// can be long after the page loaded and never at all. Events raised before then
// wait here, and stay unsent if consent never comes.
export function trackHeapEvent(
  name: string,
  properties: HeapProperties = {}
): void {
  if (window.heap) {
    window.heap.track(name, properties)
    return
  }

  subscribe(flushPending)
  pending.push({ name, properties })
}
